const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    reviewratingEle: document.querySelector('.product-details-wrapper [data-hulkapps-reviews]'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]')
};
const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class templateProductJS {
    constructor() {
        if (selectors.reviewratingEle) {
            selectors.reviewratingEle.addEventListener('click', (event) => {
                event.preventDefault();
                const reviewSection = document.querySelector('#hulk__product-review');
                if (reviewSection) reviewSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            });
        }

        selectors.zoomBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });



        // var count = 0;
        // var x = setInterval(function () {
        //     let btn = document.querySelector('.customize-btn');
        //     if (document.querySelector('.mw-apo-container') != null ) {
        //         btn.classList.remove('d-none');
        //         clearInterval(x);
        //     }else if(count >=3){
        //         clearInterval(x)
        //     }
        //     count++;
        // }, 3000);

        // if (document.querySelector('[data-btn_customize]') != null && document.querySelector('[data-apply_customize]') != null) {
        //     document.querySelector('[data-btn_customize]').addEventListener('click', (event)=>{
        //         document.querySelector('.mw-apo-container').classList.add('d-block');
        //         event.target.closest('[data-btn_customize]').classList.add('d-none');
        //         document.querySelector('[data-apply_customize]').classList.remove('d-none');

        //         document.body.scrollTop = 0;
        //         document.documentElement.scrollTop = 0;
        //     });
        //     document.querySelector('[data-apply_customize]').addEventListener('click', (event)=>{
        //         document.querySelector('[data-btn-add_to_cart]').classList.remove('disabled');
        //         document.querySelector('[data-apply_customize]').classList.add('d-none');
        //         document.querySelector('[data-apply_customize]').classList.add('applied');

        //         document.querySelector('[data-btn_customize]').classList.remove('d-none');
        //         document.querySelector('.mw-apo-container').classList.remove('d-block');
        //         window.scrollTo({top: 0, behavior: 'smooth'});
        //     })



        //     let interval=setInterval(() => {
        //         if (document.querySelector('.mw-apo-container') != null) {
        //             this._checkRulesInCustomButton();
        //         }
        //     }, 1000);
        // }

        var elementToObserve = document.querySelector('[data-product-container]');
        if (elementToObserve != null) {
            const observer = new MutationObserver(function () {
                if (document.querySelector('.product-details-wrapper [data-rating]') != null) {
                    if (document.querySelector('.product-details-wrapper [data-rating="0.0"]') != null) {
                        document.querySelector('.product-details-wrapper [data-no_review_text]').classList.remove('d-none');
                    } else {
                        document.querySelector('.product-details-wrapper [data-no_review_text]').classList.add('d-none');
                    }
                }

                if (document.querySelector('.btn-beatanyprice') == null) {
                    document.querySelector('[data-price_match_button]').classList.add('is--opacity-0');
                } else {
                    document.querySelector('[data-price_match_button]').classList.remove('is--opacity-0');
                }
            });
            observer.observe(elementToObserve, { childList: true, subtree: true });
        }
        document.querySelector('[data-price_match_button]').addEventListener('click', function () {
            if (document.querySelector('.btn-beatanyprice') != null) {
                document.querySelector('.btn-beatanyprice').click();
            }
        })

        if (document.querySelector('[data-btn-add_to_cart]')) {
            document.querySelector('[data-btn-add_to_cart]').addEventListener('click', () => {
                document.querySelector('[data-btn-add_to_cart]').classList.add('loading');
                setTimeout(() => {
                    if (document.querySelectorAll('.mw-option:not(.mw-hidden) .mw-option__helptext:not(.mw-hidden)').length == 0) {
                        document.querySelector('[data-btn-add_to_cart]').classList.remove('loading');
                    }
                }, 1000);
            })
        }

        if (document.getElementById('quote-btn') != null) {
            document.getElementById('quote-btn').addEventListener('click', function (event) {
                let currentId = event.target.closest('form').querySelector('[name="id"]').value;
                for (var variant of productJson.product.variants) {
                    if (variant.id == parseInt(currentId)) {
                        document.querySelector('#PopupModal-quote #hidden').value = variant.sku;
                    }
                }
            });
        }
    }
    _checkRulesInCustomButton() {
        var customize_flag = false;
        if (document.querySelectorAll('.mw-option:not(.mw-hidden) .mw-option__helptext:not(.mw-hidden)').length == 0) {
            document.querySelector('[data-apply_customize]').classList.remove('disabled');
            customize_flag = true;
        } else {
            document.querySelector('[data-apply_customize]').classList.add('disabled');
            document.querySelector('[data-apply_customize]').classList.remove('applied');

            customize_flag = false;
        }

        // if (document.querySelector('[data-apply_customize]').classList.contains('applied')) {
        //     if (document.querySelector('[data-apply_customize]').classList.contains('disabled') && customize_flag) {
        //         document.querySelector('[data-btn-add_to_cart]').classList.add('disabled');
        //     }else{
        //         document.querySelector('[data-btn-add_to_cart]').classList.remove('disabled');
        //     }
        // }else{
        //     document.querySelector('[data-btn-add_to_cart]').classList.add('disabled');
        // }

    }
    manageVariantSlider(variant) {
        const productJSON = window.globalVariables.product;
        const productSliderType = selectors.productContainer.dataset.slider_type;

        if (productSliderType == 'color-based' && productJSON.options && productJSON.options.includes('Color') || productJSON.options.includes('color') || productJSON.options.includes('COLOR')) {
            const currentVariant = variant || window.globalVariables.product.currentVariant;
            const colorName = currentVariant.option1.toLowerCase();
            const colorMedia = [];
            mediaJSON.forEach(media => {
                let mediaAlt = media.alt;
                if (mediaAlt) mediaAlt = mediaAlt.toLowerCase();
                // if(mediaAlt == colorName) colorMedia.push(media);
            });
            window.productMedia = colorMedia;

            if (window.globalVariables.templateSuffix == 'layout2') {
                const imagesParent = document.querySelector('[data-productImagesContainer]');
                if (!imagesParent || colorMedia.length <= 0) return;
                let slidesHTML = '';
                colorMedia.forEach(function (i, v) {
                    let imageAlt = i.alt.toLowerCase();
                    if (imageAlt == colorName) {
                        if (i.media_type == "external_video") {
                            slidesHTML += `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else if (i.media_type == "video") {
                            slidesHTML += `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else {
                            slidesHTML += `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });
                imagesParent.innerHTML = slidesHTML;
            } else {
                const thumbParent = document.querySelector('[data-thumbSlider]');
                const sliderParent = document.querySelector('[data-main-slider]');

                if (!thumbParent || !sliderParent || colorMedia.length <= 0) return;

                let thumbnailsHTML = '';
                let slidesHTML = '';
                colorMedia.forEach(function (i, v) {
                    let imageAlt = i.alt.toLowerCase();
                    if (imageAlt == colorName) {
                        if (i.media_type == "external_video") {
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                            </div>`;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else if (i.media_type == "video") {
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                            </div>`;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else {
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });

                let navDirection = thumbParent.dataset.direction || 'horizontal';
                let finalnavHTML = `
                    <div class="swiper-slider product-thumbnails" role="tree" 
                            data-slider='{
                                "direction": "${navDirection}",
                                "loop": false,
                                "slidesPerView": "6",
                                "spaceBetween": 15,
                                "grabCursor": true,
                                "slideToClickedSlide": true
                            }' >
                        <div class="swiper-wrapper">${thumbnailsHTML}</div>
                    </div>`;
                thumbParent.innerHTML = finalnavHTML;

                let finalHTML = `<slider-element class="swiper-container carousel">
                                    <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails"
                                        data-slider='{
                                                "loop": false,
                                                "slidesPerView": "1",
                                                "spaceBetween": 15,
                                                "grabCursor": true,
                                                "navigation": {
                                                    "nextEl": ".swiper-button-next",
                                                    "prevEl": ".swiper-button-prev"
                                                },
                                                "pagination": {
                                                    "el": ".swiper-pagination"
                                                }
                                            }' role="tree">
                                        <div class="swiper-wrapper" >${slidesHTML}</div>
                                        <div class="swiper-pagination"></div>
                                    </div>
                                </slider-element>`;
                sliderParent.innerHTML = finalHTML;
            }

            selectors.zoomBtns = document.querySelectorAll('[data-productZoom]');
            selectors.zoomBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    let currentTarget = event.target;
                    this.manageZoom(currentTarget);
                })
            });
        }
    }

    manageZoom(currentTarget) {
        let currentSlide = currentTarget.closest('.product--media');
        let currentSlideIndex = 1;
        if (currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);

        let zoomSlider = '';
        window.productMedia.forEach(i => {
            if (i.media_type == "external_video") {
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                    <div class="custom-video-container">
                        <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                            <div class="cta-btn" data-aos="hero">
                                <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                    <i class="icon-play text-body"></i>
                                </button>
                                <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                    <i class="icon-pause"></i>
                                </button>
                            </div>
                            <div class="content-section">
                                <div class="poster-image">
                                    <img class="img-fluid"
                                    src="${i.preview_image.src}"
                                    alt="${i.alt}"/>
                                </div>
                            </div>
                            <div class="video-section" tabindex="0"></div>
                        </custom-video>
                    </div>
                </div>`;
            } else if (i.media_type == "video") {
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                    <div class="custom-video-container">
                        <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                            <div class="cta-btn">
                                <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                    <i class="icon-play text-body"></i>
                                </button>
                                <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                    <i class="icon-pause"></i>
                                </button>
                            </div>
                            <div class="content-section">
                                <div class="poster-image">
                                    <img class="img-fluid"
                                    src="${i.preview_image.src}"
                                    alt="${i.alt}"/>
                                </div>
                            </div>
                            <div class="video-section" tabindex="0"></div>
                        </custom-video>
                    </div>
                </div>`;
            } else if (i.media_type == "image") {
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                    <img class="img-fluid"
                    src="${i.preview_image.src}"
                    alt="${i.alt}"/>
                </div>`;
            }
        });
        let finalHTML = `<slider-element class="swiper-container carousel">
            <div class="swiper swiper-slider zoom--product-images"
                data-slider='{
                        "loop": false,
                        "observer": true,
                        "observeParents": true,
                        "slidesPerView": "1",
                        "spaceBetween": 15,
                        "grabCursor": true,
                        "navigation": {
                            "nextEl": ".swiper-button-next",
                            "prevEl": ".swiper-button-prev"
                        },
                        "pagination": {
                            "el": ".swiper-pagination"
                        }
                    }' role="tree">
                <div class="swiper-wrapper" >${zoomSlider}</div>
                <div class="swiper-pagination"></div>

                <div class="swiper-button-prev icon-previous"></div>
                <div class="swiper-button-next icon-next"></div>

            </div>
        </slider-element>`;

        const zoomContainer = document.getElementById('PopupModal-zoom');
        if (zoomContainer) {
            zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
            zoomContainer.show();
            if (productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
        }
    }
}

setTimeout(() => {
    var open_drawer = localStorage.getItem('open_cart');
    if (open_drawer != undefined && open_drawer == 'true') {
        document.querySelector('ajax-cart').getCartData('open_drawer')
        localStorage.removeItem('open_cart')
    }
}, 1500);
typeof templateProductJS !== 'undefined' && new templateProductJS();
